import { BasicColumn } from '/@/components/Table';

export const columns: BasicColumn[] = [
  {
    title: 'Key',
    dataIndex: 'key',
    width: 100,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    width: 80,
  },
  {
    title: 'Value',
    dataIndex: 'value',
    width: 80,
  },
];
